import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser, type User } from '@/api/entities/users';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { GraphQLRequestError } from '@/api/graphql';

type QueryFnType = typeof createUser;

type UseCreateUserOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useCreateUser = ({ config }: UseCreateUserOptions = {}) => {
  const queryClient = useQueryClient();
  const { getAccessToken } = useCognitoAuth();

  return useMutation<ExtractFnReturnType<QueryFnType>, GraphQLRequestError, Partial<User>>({
    ...config,
    mutationFn: async (input: Partial<User>) => {
      return createUser(input, getAccessToken);
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      config?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
